import { Nat }		from "ts-base/numeric/nat";

import { Numeric }	from "@v3/data/numeric";

export type PortNumber	= Numeric.Value<typeof PortNumber>;
export const PortNumber	= Numeric.fromBase(Nat, "must be a port number between 0 and 65535").constrain("PortNumber", 0, 65335);
